import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquicheck-box-group',
	templateUrl:'./JQUICheckBoxGroupPage.html',
	styles: [],
	styleUrls:['./JQUICheckBoxGroupPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUICheckBoxGroupPage
{
	mdContent_188 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.checkboxradio.JQUICheckBoxGroup;
\`\`\``;
	mdContent_189 = `\`\`\`java
new JQUICheckBoxGroup&lt;&gt;()
\`\`\``;
	mdContent_190 = `\`\`\`java
var group = new JQUICheckBoxGroup<>();
group.addCheckBox("Option A", "a");
group.addCheckBox("Option B", "b");
\`\`\``;
}
